/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfBoolean } from '../../models/platform-api-result-of-boolean';
import { PlatformOleAanwezigMelden } from '../../models/platform-ole-aanwezig-melden';

export interface PostUserpresenceActionOleaanwezigmelden$Params {
      body: PlatformOleAanwezigMelden
}

export function postUserpresenceActionOleaanwezigmelden(http: HttpClient, rootUrl: string, params: PostUserpresenceActionOleaanwezigmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
  const rb = new RequestBuilder(rootUrl, postUserpresenceActionOleaanwezigmelden.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfBoolean>;
    })
  );
}

postUserpresenceActionOleaanwezigmelden.PATH = '/api/userpresence/action/oleaanwezigmelden';
